import { SeeMorePublicationsCategoriesSkeleton } from 'components/discover/publications/see-more/skeletons/see-more-publications-skeleton';
import { VideoBrowserTemplate } from 'components/discover/publications/video-browser/template/video-browser-template';
import { range } from 'lodash-es';
import { FC } from 'react';
import styled from 'styled-components';

const StyledThumbnail = styled.div`
  width: 914px;
  height: 514px;
`;

const StyledVideoList = styled.div`
  width: 10000px;
  height: 152px;
`;

const StyledVideoItem = styled.div`
  width: 250px;
`;

export const VideoBrowserSkeleton: FC = () => (
  <VideoBrowserTemplate leftPane={<SeeMorePublicationsCategoriesSkeleton categoryCount={8} />}>
    <StyledThumbnail className="bg-dark border-secondary border-top border-opacity-70" />
    <StyledVideoList className="d-flex overflow-hidden justify-content-start p-3 border-secondary border-top border-opacity-70">
      {range(0, 5).map(idx => (
        <StyledVideoItem key={idx} className="me-3 bg-secondary" />
      ))}
    </StyledVideoList>
  </VideoBrowserTemplate>
);
